import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { preventRenderWithOpenFilter } from 'lib/offer/offerPageUtil'
import {
  arePropertyRatesLoading,
  getPropertyCheapestRates,
  getPropertyRatesKey,
} from 'selectors/offerPage/offerPageSelectors'

import _BaseHotelFlightsToggleButton from './_BaseHotelFlightsToggleButton'

interface Props {
  property: App.Property.Property | undefined
  areAnytimeRates: boolean
  shouldShowAnytimeRate: boolean
  isLoading: boolean
  cheapestPropertyRates: [App.PropertyRate | App.Property.AnytimeRate | undefined, App.PropertyRate | undefined]
}

function SinglePropertyHotelFlightsToggleButton(props: Props) {
  const {
    property,
    areAnytimeRates,
    shouldShowAnytimeRate,
    isLoading,
    cheapestPropertyRates,
  } = props

  /************************************************************************************************/
  /* STOP! Do not add any more hooks for deriving packages/rooms or options/rates to this         */
  /* component! This logic is being refactored out into selectors! If you _need_ to add new       */
  /* logic, speak to Xiao.                                                                        */
  /************************************************************************************************/

  const [hotelOnlyRate, hotelWithFlightsRate] = cheapestPropertyRates

  const hideAnytimePrices = areAnytimeRates && !shouldShowAnytimeRate
  const [hotelPrice, hotelMemberPrice, hotelFlightPrice] = hideAnytimePrices ? [0, 0, 0] : [
    hotelOnlyRate?.totals.displayPrice ?? 0,
    hotelOnlyRate?.luxPlusTotals?.displayPrice ?? 0,
    hotelWithFlightsRate?.luxPlusTotals?.displayPrice ?? hotelWithFlightsRate?.totals.displayPrice ?? 0,
  ]

  // Only show LuxPlus+ badging if the member price is _better_ than the non-member price.
  const showMemberPrice = !!hotelMemberPrice && hotelMemberPrice < hotelPrice
  const hotelTotalPrice = showMemberPrice ? hotelMemberPrice : hotelPrice

  return <_BaseHotelFlightsToggleButton
    flightsAvailable={!!property?.areFlightsEnabled}
    isMemberPrice={showMemberPrice}
    hotelTotalPrice={hotelTotalPrice}
    hotelFlightTotalPrice={hotelTotalPrice !== hotelFlightPrice ? hotelFlightPrice : undefined}
    pricesLoading={isLoading}
  />
}

export default withOfferPageAndReduxState((state, appState) => ({
  property: state.property,
  areAnytimeRates: !getPropertyRatesKey(state, appState),
  // We only need to show anytime pricing for traffic coming from marketing, which will have
  // `utm_bp` set.
  shouldShowAnytimeRate: !!appState.utm.bp,
  isLoading: arePropertyRatesLoading(state, appState),
  cheapestPropertyRates: getPropertyCheapestRates(state, appState),
  open: !!state.activeFilter,
}), SinglePropertyHotelFlightsToggleButton, preventRenderWithOpenFilter)
